"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.labels = void 0;
const labels = exports.labels = {
  he: {
    mobile_compatible: 'מותאם למובייל',
    new: 'חדש',
    attached: 'שוייך',
    hours: 'שעות',
    minutes: "דק'",
    yearly: 'שנתי'
  },
  ar: {
    mobile_compatible: 'ملاءَم للخلويّ',
    new: 'جديد',
    attached: 'أضيف',
    hours: 'ساعات',
    minutes: 'د.',
    yearly: 'سنويّ'
  },
  en: {
    mobile_compatible: 'Mobile compatible',
    new: 'New',
    attached: 'Attached',
    hours: 'hours',
    minutes: 'minutes',
    yearly: 'yearly'
  }
};